export default "__VITE_ASSET__xbhCyTst__"